import React from "react";
import styled from "styled-components";

import { TeksCategory, TeksCurriculumUsage } from "@examspark/types";

import { TeksCategoryColors, TeksIndicatorInitials } from "../objectives";

const StyledBadge = styled.div<{ color: string }>`
  width: 1.8rem;
  height: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => p.color};
  color: #fff;
  border-radius: 100%;
  padding: 0.4rem;
  font-family: sans-serif;
  font-size: 0.8rem;
`;

type Props = {
  value: TeksCurriculumUsage | TeksCategory | undefined;
};

const ObjectiveIndicator = ({ value }: Props) => {
  if (value == null) {
    return <StyledBadge color="transparent">&nbsp;</StyledBadge>;
  }

  const character = TeksIndicatorInitials[value];
  let color = "#999";

  switch (value) {
    case "PROCESS":
    case "READINESS":
    case "SUPPORTING":
    case "RTC":
    case "SEP":
      color = TeksCategoryColors[value];
      break;
  }

  return <StyledBadge color={color}>{character}</StyledBadge>;
};

export default ObjectiveIndicator;
